// src/Components/Icons/AboutIcon.tsx
import React from 'react';
import styled from 'styled-components';

const StyledAboutIcon = styled.svg`
  width: 30px;
  height: 30px;
  filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.3));
  transition: fill 0.2s ease;
`;

const AboutIcon: React.FC = () => (
  <StyledAboutIcon viewBox="0 0 24 24">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92c-.72.73-1.17 1.33-1.17 2.83h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" />
  </StyledAboutIcon>
);

export default AboutIcon;